import { CreditNoteRepository } from "../repositories/CreditNoteRepository";
import {
  CreditNoteOperationResult,
  CreditNoteDataEntity,
} from "../entities/CreditNoteEntity";

/**
 * Update Credit Note JSON Use Case
 * Updates credit note JSON data (for auto-save and manual edits)
 */
export class UpdateCreditNoteJsonUseCase {
  constructor(private repository: CreditNoteRepository) {}

  async execute(
    creditNoteId: number,
    creditNoteData: CreditNoteDataEntity
  ): Promise<CreditNoteOperationResult> {
    return await this.repository.updateCreditNoteJson(
      creditNoteId,
      creditNoteData
    );
  }
}
